import React, { Fragment } from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const RichText = props => {
	const { content } = props
	return <Fragment>{documentToReactComponents(content)}</Fragment>
}

export default RichText
